import { createVNode as _createVNode } from "vue";
import { defineComponent } from "vue";
import { truthProp, createNamespace } from "../utils";
import { useChildren } from "@vant/use";
const [name, bem] = createNamespace("action-bar");
const ACTION_BAR_KEY = Symbol(name);
const actionBarProps = {
  safeAreaInsetBottom: truthProp
};
var stdin_default = defineComponent({
  name,
  props: actionBarProps,
  setup(props, {
    slots
  }) {
    const {
      linkChildren
    } = useChildren(ACTION_BAR_KEY);
    linkChildren();
    return () => {
      var _a;
      return _createVNode("div", {
        "class": [bem(), {
          "van-safe-area-bottom": props.safeAreaInsetBottom
        }]
      }, [(_a = slots.default) == null ? void 0 : _a.call(slots)]);
    };
  }
});
export {
  ACTION_BAR_KEY,
  stdin_default as default
};
